//@flow
import DataUtils from 'common/utils/DataUtils';
import * as Immutable from 'immutable';
import { SalesChannel } from 'common/models/internal/SalesChannel';

export class PjpImportHelper {
    static validateChannels({ header, entity, entitySettings }) {
        const accessor = header.getAccessor();
        const channels = entity.getIn(accessor);

        if (channels.size) {
            const { salesChannels = Immutable.List() } =
                entitySettings.pjpSettings || {};
            const validChannels = salesChannels.map(({ id }) => id).toList();
            return SalesChannel.getChannelValidationMessage({
                validChannels,
                channels
            });
        }
    }

    static serializeChannels = (
        value: Array<string>,
        {
            salesChannels
        }: {
            salesChannels: Immutable.List<SalesChannelsModelType>
        }
    ): Immutable.List<SalesChannelsModelType> => {
        return Immutable.List(
            value?.map(channelId => {
                const salesChannel: ?SalesChannelsModelType = salesChannels?.find(
                    ({ id }) => id === channelId
                );
                return (
                    salesChannel ||
                    SalesChannel.fromJS({
                        id: channelId,
                        name: ''
                    })
                );
            })
        );
    };

    static setChannelsInTemplateRow(
        existingTemplateRow,
        allowedChannels,
        translation
    ) {
        const allowedChannelIds = allowedChannels.map(channel => channel.id);
        existingTemplateRow[translation] = allowedChannelIds.join();
        return existingTemplateRow;
    }

    static processChannelPreferences({ cellValue }): Immutable.List<string> {
        return !DataUtils.isEmpty(cellValue)
            ? cellValue
                  .split(',')
                  .filter(channel => channel?.trim())
                  .map(channel => channel.trim())
            : [];
    }
}

export default PjpImportHelper;
